import ServiceTemplate from '@/components/ServiceTemplate';

export default function TrademarkMonitoring() {
  const data = {
    title: 'Trademark Monitoring Services',
    subtitle: 'Continuous monitoring to protect your trademark from infringement and unauthorized use.',
    overviewTitle: 'Why Monitor Your Trademark?',
    overviewImage: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
    description: [
      'Trademark monitoring is essential for protecting your brand investment. Once registered, your trademark requires active policing to prevent unauthorized use and maintain its strength and enforceability.',
      'Our comprehensive monitoring service tracks new trademark applications, domain registrations, and marketplace activity that could conflict with your mark. Early detection allows for timely opposition or enforcement action.',
      'We provide regular reports on potential infringements and strategic recommendations for protecting your brand rights in the marketplace.'
    ],
    benefits: [
      { title: 'Early Detection', description: 'Identify potential infringements before they become established.' },
      { title: 'Brand Protection', description: 'Maintain trademark strength and prevent dilution.' },
      { title: 'Competitive Intelligence', description: 'Monitor competitor trademark activity in your industry.' },
      { title: 'Enforcement Support', description: 'Receive strategic guidance on enforcement actions.' },
      { title: 'Regular Reporting', description: 'Detailed reports on monitored activity and findings.' },
      { title: 'Global Coverage', description: 'Monitor trademark activity across multiple jurisdictions.' }
    ],
    process: [
      { title: 'Setup & Configuration', description: 'Initial assessment and configuration of monitoring parameters tailored to your needs.' },
      { title: 'Continuous Monitoring & Analysis', description: 'Ongoing surveillance and expert analysis of findings with actionable intelligence.' },
      { title: 'Action & Protection', description: 'Strategic guidance and implementation of protection measures when threats are identified.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential trademark filing',
        price: '$599',
        period: '+ USPTO fees ($250-$350)',
        features: [
          'Preliminary trademark search',
          'Single class filing',
          'USPTO application preparation',
          'Filing with USPTO',
          'Email support',
          'Status monitoring'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete trademark package',
        price: '$999',
        period: '+ USPTO fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Comprehensive search report',
          'Multi-class discounts available',
          'Office action response (1 included)',
          'Priority processing',
          'Trademark monitoring (6 months)',
          'Phone & email support'
        ]
      },
      {
        name: 'Premium',
        description: 'Full-service trademark protection',
        price: '$1,499',
        period: '+ USPTO fees',
        features: [
          'Everything in Professional',
          'Global trademark search',
          'Unlimited office action responses',
          'International filing coordination',
          'Trademark monitoring (12 months)',
          'Enforcement support',
          'Dedicated attorney access'
        ]
      }
    ],
    faqs: [
      { question: 'What does trademark monitoring include?', answer: 'Monitoring includes new trademark applications, domain registrations, marketplace listings, and social media presence that could conflict with your mark.' },
      { question: 'How often will I receive reports?', answer: 'Standard monitoring provides monthly reports, though more frequent reporting is available based on your needs.' },
      { question: 'Do you monitor internationally?', answer: 'Yes, we offer international monitoring covering major trademark offices and marketplaces worldwide.' },
      { question: 'What happens when a conflict is found?', answer: 'We analyze the conflict, assess infringement risk, and provide strategic recommendations including opposition, cease and desist, or negotiation options.' },
      { question: 'Is monitoring required after registration?', answer: 'While not legally required, monitoring is strongly recommended to protect your trademark investment and maintain enforcement rights.' },
      { question: 'Can you help with enforcement?', answer: 'Yes, we provide full enforcement support including cease and desist letters, oppositions, and litigation if necessary.' },
      { question: 'How long should I monitor my trademark?', answer: 'Ongoing monitoring is recommended throughout the life of your trademark to maintain protection and prevent unauthorized use.' },
      { question: 'What if I find someone using my trademark?', answer: 'We help evaluate the use, determine if it constitutes infringement, and recommend appropriate enforcement action to protect your rights.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
